import { LogItemProps } from './LogItemLayout';
import { LogItemTask } from './LogItemTask';
import { LogItemRound } from './LogItemRound';
import { LogItemPolicy } from './LogItemPolicy';

export const LogItem = (props: LogItemProps) => {
  const { data } = props;
  const { operateType } = data;

  if (
    operateType === 'CREATE_TASK' ||
    operateType === 'DELETE_TASK' ||
    operateType === 'UPDATE_TASK'
  ) {
    return <LogItemTask {...props} />;
  }

  if (
    operateType === 'CREATE_ROUND' ||
    operateType === 'DELETE_ROUND' ||
    operateType === 'UPDATE_ROUND'
  ) {
    return <LogItemRound {...props} />;
  }

  if (
    operateType === 'CREATE_POLICY' ||
    operateType === 'DELETE_POLICY' ||
    operateType === 'MODIFY_POLICY_PRIORITY' ||
    operateType === 'UPDATE_POLICY'
  ) {
    return <LogItemPolicy {...props} />;
  }

  return null;
};
